import { type PropsWithChildren } from 'react';
import { classNames } from '@utils/classNames.ts';

export function Heading3({
  id,
  children,
  className,
}: PropsWithChildren<{ id?: string; className?: string }>) {
  return (
    <h1
      id={id}
      className={classNames(
        'text-slate-900 text-2xl tracking-normal font-medium lg:text-3xl',
        className,
      )}
    >
      {children}
    </h1>
  );
}
